import { render, staticRenderFns } from "./subNav.vue?vue&type=template&id=5f21d142"
import script from "./subNav.vue?vue&type=script&lang=js"
export * from "./subNav.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/common/subNav.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports